import axios from "axios";

export const getUser = async (userID: any) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API}/User/get-user?UserID=${userID}`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
